const config = {
    apiGateway: {
        URL: process.env.REACT_APP_API_URL,
    },
    bridTV: {
        BRIDTV_PLAYER_ID: process.env.REACT_APP_BRIDTV_PLAYER_ID,
    },
    client: {
        CHANNEL_CLIENT_NAME: process.env.REACT_APP_CLIENT_NAME,
        CHANNEL_CLIENT_EMAIL: process.env.REACT_APP_CLIENT_EMAIL,
        CHANNEL_CLIENT_WEBSITE: process.env.REACT_APP_CLIENT_WEBSITE,
    },
};
  
export default config;